<script>
    import Layout from "../../layouts/main";
    import PageHeader from "../../components/page-header";
    import producerCompanyList from "./producer-company-list";
    export default {
    components: { Layout, PageHeader, producerCompanyList },
    data() {
        return {};
    }
    };

</script>

<template>
  <Layout>
    <producer-company-list/>
  </Layout>
</template>